// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"styles_iconContainer__XFZIj","icon":"styles_icon__1p_L8","icon--black":"styles_icon--black__1P_-i","iconContainer--red":"styles_iconContainer--red__3BgKu"};